export default "__VITE_ASSET__Chfaw1Rw__"